import { render, staticRenderFns } from "./PurchaseOrderManagerList.vue?vue&type=template&id=67454e86"
import script from "./PurchaseOrderManagerList.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderManagerList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderManagerList.vue?vue&type=style&index=0&id=67454e86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports